import React, { createContext, useState, useContext } from 'react';

// Create a Context for authentication
const 
chatAuthContext = createContext();

// Custom hook to use authentication context
export const useChatAuth = () => {
  return useContext(chatAuthContext);
};

// AuthProvider to wrap the application and provide authentication state
export const ChatAuthProvider = ({ children }) => {
  const isauth = !localStorage.getItem('adminChatauthToken');
  const [ischatAuthenticated, setIschatAuthenticated] = useState(!isauth);
  const chatlogin = () => {
    setIschatAuthenticated(true);
  };
  

  const chatlogout = () => {
    setIschatAuthenticated(false);
  };

  return <chatAuthContext.Provider value={{ ischatAuthenticated, chatlogin, chatlogout }}>{children}</chatAuthContext.Provider>;
};
